// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"80":"ec02f086","175":"7ebcc4f9","853":"39b875f0","910":"54392394","979":"efe6bba9"}[chunkId] + ".chunk.js";
};